export default __webpack_public_path__ + "static/media/spring-boot.94f201ce.png";